import { v4 as uuidv4 } from 'uuid';
import { DisclosureContent } from '../../../../vtex-apps/disclosure-layout/DisclosureContent/default';
import { DisclosureLayout } from '../../../../vtex-apps/disclosure-layout/DisclosureLayout/default';
import { DisclosureStateIndicator } from '../../../../vtex-apps/disclosure-layout/DisclosureStateIndicator/default';
import { DisclosureTrigger } from '../../../../vtex-apps/disclosure-layout/DisclosureTrigger/default';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { IconCaret } from '../../../../vtex-apps/icons/default';
import { Menu } from '../../../../vtex-apps/menu/Menu/default';
import { MenuItem } from '../../../../vtex-apps/menu/MenuItem/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

// this template needs to have a templateId of 4, this is an exception, not a rule
const InstitutionalGroup = () => {
	return {
		componentName: 'FlexLayoutRow',
		componentGroup: 'InstitutionalGroup',
		componentId: uuidv4(),
		templateId: 4,
		variables,
		props: FlexLayoutRow({
			mzTitle: 'MZ | Bloco institucional',
			blockClass: 'flex-row-container__inst-group-4',
			marginTop: { desktop: 8, tablet: 8, phone: 8 },
		}).props,
		childrenComponents: [
			FlexLayoutCol(
				{
					mzTitle: 'MZ | Menu',
					blockClass: 'menu-col__inst-group-4',
					width: { desktop: '20%', mobile: '100%' },
				},
				[
					DisclosureLayout({ animated: true, initialVisibility: 'visible' }, [
						DisclosureTrigger({ blockClass: 'menu-trigger__inst-group-4', as: 'div' }, [
							RichText({
								mzTitle: 'MZ | Título Menu',
								blockClass: 'menu-header__inst-group-4',
								text: '### Menu Institucional',
							}),
							DisclosureStateIndicator({
								Show: IconCaret({
									orientation: 'up',
									activeClassName: 'disclosure-trigger__inst-group-4',
									mutedClassName: 'disclosure-trigger__inst-group-4',
									handle:
										'caretIcon--disclosure-trigger__inst-group-4 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger__inst-group-4',
								}),
								Hide: IconCaret({
									orientation: 'down',
									activeClassName: 'disclosure-trigger__inst-group-4',
									mutedClassName: 'disclosure-trigger__inst-group-4',
									handle:
										'caretIcon--disclosure-trigger__inst-group-4 caretIcon vtex-store-icons-0-x-caretIcon vtex-store-icons-0-x-caretIcon--disclosure-trigger__inst-group-4',
								}),
							}),
						]),
						DisclosureContent({ blockClass: 'disclosure-content__inst-group-4' }, [
							Menu({ blockClass: 'menu__inst-group-4', orientation: 'vertical' }, [
								VisibilityLayout({ mzTitle: 'MZ | Menu item 1 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: { href: '#', tagTitle: 'Sobre a Marca', text: 'Sobre a Marca' },
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 2 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: {
											href: '#',
											tagTitle: 'Central de Atendimento',
											text: 'Central de Atendimento',
										},
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 3 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: { href: '#', tagTitle: 'Televendas', text: 'Televendas' },
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 4 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: { href: '#', tagTitle: 'Nossas Lojas', text: 'Nossas Lojas' },
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 5 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: {
											href: '#',
											tagTitle: 'Trabalhe Conosco',
											text: 'Trabalhe Conosco',
										},
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 6 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: {
											href: '#',
											tagTitle: 'Trocas, Devoluções e Garantia',
											text: 'Trocas, Devoluções e Garantia',
										},
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 7 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: {
											href: '#',
											tagTitle: 'Politica de Privacidade',
											text: 'Politica de Privacidade',
										},
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 8 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: {
											href: '#',
											tagTitle: 'Política de Entrega',
											text: 'Política de Entrega',
										},
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 9 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: { href: '#', tagTitle: 'Regras do Site', text: 'Regras do Site' },
									}),
								]),
								VisibilityLayout({ mzTitle: 'MZ | Menu item 10 (On/Off)' }, [
									MenuItem({
										blockClass: 'menu-item__inst-group-4',
										id: 'custom-1',
										itemProps: {
											href: '#',
											tagTitle: 'Guia de Segurança',
											text: 'Guia de Segurança',
										},
									}),
								]),
							]),
						]),
					]),
				],
			),
			FlexLayoutCol({ width: { desktop: '80%', mobile: '100%' }, marginLeft: { desktop: 9, tablet: 0, phone: 0 } }, [
				VisibilityLayout({ mzTitle: 'MZ | Título Conteúdo (On/Off)' }, [
					RichText({
						mzTitle: 'MZ | Título Conteúdo',
						blockClass: 'header__inst-group-4',
						text: '# Fale Conosco',
					}),
				]),
				VisibilityLayout({ mzTitle: 'MZ | Conteúdo 1 (On/Off)' }, [
					RichText({
						mzTitle: 'MZ | Conteúdo 1',
						blockClass: 'body__inst-group-4',
						text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
					}),
				]),
				VisibilityLayout({ mzTitle: 'MZ | Conteúdo 2 (On/Off)' }, [
					RichText({
						mzTitle: 'MZ | Conteúdo 2',
						blockClass: 'body__inst-group-4',
						text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
					}),
				]),
				VisibilityLayout({ mzTitle: 'MZ | Conteúdo 3 (On/Off)' }, [
					RichText({
						mzTitle: 'MZ | Conteúdo 3',
						blockClass: 'body__inst-group-4',
						text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
					}),
				]),
				VisibilityLayout({ mzTitle: 'Visibilidade Contatos' }, [
					FlexLayoutRow(
						{
							mzTitle: 'MZ | Contato',
							blockClass: 'icon-row__inst-group-4',
							marginTop: { desktop: 6, tablet: 5, phone: 5 },
						},
						[
							FlexLayoutCol({ width: { desktop: '40%', mobile: '100%' } }, [
								FlexLayoutRow(
									{
										blockClass: 'icon-row-item__inst-group-4',
										marginBottom: { desktop: 0, tablet: 6, phone: 6 },
										preserveLayoutOnMobile: true,
										horizontalAlign: 'left',
										colGap: { desktop: 4, tablet: 4, phone: 4 },
									},
									[
										Image({
											blockClass: 'icon-img__inst-group-4',
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1667572386000-phone-icon.png',
										}),
										RichText({
											blockClass: 'icon-text__inst-group-4',
											text: `**(024) 3345-4000** \n de seg a sex das 10h ás 19h sab das 09h ás 12h`,
										}),
									],
								),
							]),
							FlexLayoutCol({ width: { desktop: '50%', mobile: '100%' } }, [
								FlexLayoutRow(
									{
										blockClass: 'icon-row-item__inst-group-4',
										marginBottom: { desktop: 0, tablet: 6, phone: 6 },
										preserveLayoutOnMobile: true,
										horizontalAlign: 'left',
										colGap: { desktop: 4, tablet: 4, phone: 4 },
									},
									[
										Image({
											blockClass: 'icon-img__inst-group-4',
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1667572382000-email-icon.png',
										}),
										RichText({
											blockClass: 'icon-text__inst-group-4',
											text: '**sac@email.com**',
										}),
									],
								),
							]),
						],
					),
				]),
			]),
		],
	};
};

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--brand-color-primary-pure', to: '--inst-group-4-menu-mobile-color', name: 'Menu Title Mobile' },
			{ from: '--text-color-1', to: '--inst-group-4-menu-desktop-color', name: 'Menu Title Desktop' },
			{ from: '--text-color-1', to: '--inst-group-4-menu-item-color', name: 'Menu Item' },
			{ from: '--brand-color-primary-pure', to: '--inst-group-4-link-color', name: 'Link' },
			{ from: '--text-color-1', to: '--inst-group-4-text-color', name: 'Content' },
		],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xl', to: '--inst-group-4-menu-header-d-fs', name: 'Menu Header Desktop' },
			{ from: '--font-size-lg', to: '--inst-group-4-menu-header-m-fs', name: 'Menu Header Mobile' },
			{ from: '--font-size-sm', to: '--inst-group-4-menu-item-fs', name: 'Menu Item' },
			{ from: '--font-size-xl', to: '--inst-group-4-content-header-d-fs', name: 'Content Header Desktop' },
			{ from: '--font-size-lg', to: '--inst-group-4-content-header-m-fs', name: 'Content Header Mobile' },
			{ from: '--font-size-sm', to: '--inst-group-4-content-fs', name: 'Content' },
			{ from: '--font-size-xs', to: '--inst-group-4-cwi-fs', name: 'Content With Icon' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--inst-group-4-menu-header-ff', name: 'Menu Header' },
			{ from: '--main-font', to: '--inst-group-4-menu-item-ff', name: 'Menu' },
			{ from: '--main-font', to: '--inst-group-4-content-header-ff', name: 'Content Header' },
			{ from: '--main-font', to: '--inst-group-4-content-ff', name: 'Content' },
		],
	},
	{
		type: 'spacing',
		list: [{ from: '--spacing-nano', to: '--inst-group-4-menu-gap', name: 'Menu Item Gap' }],
	},
];
export default InstitutionalGroup;
